import React, { useState, useCallback, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { eAlertsCoreAPIEndpoint, ENDPOINTS } from '../../api';
import jwt from 'jwt-decode';
import { Helmet } from 'react-helmet';
import {
  AdditionalInformation,
  ContactInformation,
  ParcelTable,
  ReturnToSearch,
  ParcelTabs,
} from '../subscriber';

export default function Dashboard(props) {
  const token = jwt(localStorage.getItem('token'));
  const accountId = token.id;
  const { logout } = props;
  const [displayParcelTabs, setDisplayParcelTabs] = useState(false);
  const [subGroup, setSubGroup] = useState({});
  const [sortedSubs, setSortedSubs] = useState([]);
  const [error, setError] = useState('Loading...');
  const [alertTypes, setAlertTypes] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [alertsDescending, setAlertsDescending] = useState(true);

  const getSubscriptionsByAccountId = useCallback(async () => {
    await eAlertsCoreAPIEndpoint(ENDPOINTS.SUBSCRIPTION)
      .getByAccountId(accountId, pageSize, currentPage, alertsDescending)
      .then((Response) => {
        if (Response.status === 200) {
          setSortedSubs(Response.data.subscriptions);
          setPageSize(Response.data.pageSize);
          setCurrentPage(Response.data.currentPage);
          setTotalPages(Response.data.totalPages);
          setError('');
        }
      })
      .catch(() => {
        setError('Something went wrong, refresh the page to retry.');
      });
  }, [accountId, pageSize, currentPage, alertsDescending]);

  //alert types and info are pulled from the AlertTypes table
  const getAlertTypes = useCallback(async () => {
    await eAlertsCoreAPIEndpoint(ENDPOINTS.ALERT)
      .getAll()
      .then((Response) => {
        if (Response.status === 200) {
          setAlertTypes(Response.data);
        }
      });
  }, []);

  const updatePagingInfo = useCallback((pageSize, currentPage) => {
    setPageSize(pageSize);
    setCurrentPage(currentPage);
  }, []);

  const updateAlertSort = useCallback((alertsDescending) => {
    setAlertsDescending(alertsDescending);
  }, []);

  useEffect(() => {
    async function fetchDashboardInfo() {
    await getAlertTypes();
    await getSubscriptionsByAccountId();
    };
    fetchDashboardInfo();
    //session will end when the stored token expires
    const session_timeout =
      localStorage.getItem('timeout') - Date.parse(Date());
    setTimeout(() => {
      logout();
    }, session_timeout);
  }, [
    accountId,
    getSubscriptionsByAccountId,
    getAlertTypes,
    logout,
  ]);

  const showTabs = (group) => {
    setSubGroup(group);
    setDisplayParcelTabs(true);
  };
  const hideTabs = () => {
    setDisplayParcelTabs(false);
    setSubGroup({});
  };

  return (
    <Container>
      <Helmet>
        <title>Dashboard{process.env.REACT_APP_PAGETITLE_TEXT}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Row>
        <Col md="8">
          <ContactInformation accountId={accountId} />
        </Col>
        <Col md="4">
          <AdditionalInformation />
        </Col>
      </Row>
      <Row>
        <Col>
          <ReturnToSearch />
        </Col>
      </Row>
      <Row>
        <Col>
          <ParcelTable
            displayManage={showTabs}
            hideTabs={hideTabs}
            sortedSubs={sortedSubs}
            pageSize={pageSize}
            currentPage={currentPage}
            totalPages={totalPages}
            alertsDescending={alertsDescending}
            updatePagingInfo={updatePagingInfo}
            updateAlertSort={updateAlertSort}
            updateParcels={getSubscriptionsByAccountId}
            error={error}
          />
        </Col>
      </Row>
      {displayParcelTabs && (
        <Row>
          <Col>
            <ParcelTabs
              hideTabs={hideTabs}
              subscriptionGroup={subGroup}
              alertTypes={alertTypes}
              updateParcels={getSubscriptionsByAccountId}
              key={subGroup.parcelNumber}
            />
          </Col>
        </Row>
      )}
    </Container>
  );
}
